export default __webpack_public_path__ + "static/media/back.834e8e6c.svg";